const strings = {
    it: {
        errorNoExcursion: 'Non riesco a trovare l\'escursione',
        contactUs: 'Contattaci per maggiori informazioni',
        errorNoAvailability: 'Non ci sono posti disponibili per questa data',
        errorSelectAnotherDate: 'Seleziona un\'altra data o contattaci per maggiori informazioni',
        headerCheckYourOrder: 'Controlla il tuo ordine',
        headerYourData: 'I tuoi dati',
        headerPayment: 'Pagamento',
        recapHeader: 'Che <span style=\'color: #ff1053\'>fortuna</span>, sembra che ci sia ancora <span style=\'color: #ff1053\'>disponibilità</span>!',
        recapHurry: 'Ma affrettati:',
        recapHurrySeats: 'i posti potrebbero sparire mentre ci pensi!',
        recapChoice: 'Hai scelto:',
        adults: 'Adulti',
        children: 'Bambini (5-12 anni)',
        infant: 'Infanti (0-4 anni)',
        totPassengers: 'Tot. passeggeri',
        date: 'Data',
        modifyDate: 'Modifica data',
        departureTime: 'Orario di partenza',
        price: 'Prezzo',
        priceDetails: 'Dettagli prezzo',
        AMPTax: 'Tassa AMP',
        totalShort: 'Tot',
        recapCallToAction: 'Tutto ok! Avanti',
        validationErrorFillFields: 'Compila tutti i campi richiesti',
        validationErrorValidEmail: 'Inserisci un indirizzo email valido',
        validationErrorBirthDay: 'Inserisci una data di nascita valida (GG/MM/AAAA)',
        validationErrorFillInvoiceFields: 'Compila tutti i campi richiesti per la fatturazione',
        summary: 'Riepilogo',
        passengers: 'Passeggeri',
        adultsLowercase: 'adulti',
        childrenLowercase: 'bambini (5-12)',
        infantsLowercase: 'infanti (0-4)',
        personalDataCallToAction: 'Ci sei quasi! Avanti',
        yourData: 'I tuoi dati',
        tooltipDataFromOnePassenger: 'È sufficiente inserire i dati di un solo passeggero',
        name: 'Nome',
        surname: 'Cognome',
        email: 'Email',
        phone: 'Telefono',
        orderNotes: 'Note sull\'ordine',
        travelerData: 'Dati viaggiatore',
        birthDayWithFormat: 'Data di nascita (GG/MM/AAAA)',
        needInvoice: 'Serve la fattura?',
        invoiceData: 'Dati di fatturazione',
        businessName: 'Ragione Sociale',
        vat: 'Partita IVA',
        fiscalCode: 'Codice fiscale',
        registeredOffice: 'Sede legale',
        recipientCode: 'Codice destinatario o pec',
        paymentMethod: 'Metodo di pagamento',
        creditCard: 'Carta di credito',
        paymentCallToAction: 'Paga e divertiti!',
        errorTransaction: 'La transazione non è andata a buon fine',
        freeCancellation: 'Cancellazione gratuita entro 7 giorni dalla data del tour'
    },
    en: {
        errorNoExcursion: 'I can\'t find the excursion',
        contactUs: 'Contact us for more information',
        errorNoAvailability: 'There are no available seats for this date',
        errorSelectAnotherDate: 'Select another date or contact us for more information',
        headerCheckYourOrder: 'Check your order',
        headerYourData: 'Your data',
        headerPayment: 'Payment',
        recapHeader: 'What <span style=\'color: #ff1053\'>luck</span>, it seems there is still <span style=\'color: #ff1053\'>availability</span>!',
        recapHurry: 'But hurry up:',
        recapHurrySeats: 'seats could disappear while you think about it!',
        recapChoice: 'You chose:',
        adults: 'Adults',
        children: 'Children (5-12 years)',
        infant: 'Infants (0-4 years)',
        totPassengers: 'Tot. passengers',
        date: 'Date',
        modifyDate: 'Modify date',
        departureTime: 'Departure time',
        price: 'Price',
        priceDetails: 'Price details',
        AMPTax: 'AMP Tax',
        totalShort: 'Total',
        recapCallToAction: 'All right! Next',
        validationErrorFillFields: 'Fill in all required fields',
        validationErrorValidEmail: 'Enter a valid email address',
        validationErrorBirthDay: 'Enter a valid birth date (DD/MM/YYYY)',
        validationErrorFillInvoiceFields: 'Fill in all required fields for billing',
        summary: 'Summary',
        passengers: 'Passengers',
        adultsLowercase: 'adults',
        childrenLowercase: 'children (5-12)',
        infantsLowercase: 'infants (0-4)',
        personalDataCallToAction: 'You\'re almost there! Next',
        yourData: 'Your data',
        tooltipDataFromOnePassenger: 'It is sufficient to enter the data of only one passenger',
        name: 'Name',
        surname: 'Surname',
        email: 'Email',
        phone: 'Phone',
        orderNotes: 'Order notes',
        travelerData: 'Traveler data',
        birthDayWithFormat: 'Birth date (DD/MM/YYYY)',
        needInvoice: 'Need an invoice?',
        invoiceData: 'Billing data',
        businessName: 'Business name',
        vat: 'VAT',
        fiscalCode: 'Fiscal code',
        registeredOffice: 'Registered office',
        recipientCode: 'Recipient code or pec',
        paymentMethod: 'Payment method',
        creditCard: 'Credit card',
        paymentCallToAction: 'Pay and have fun!',
        errorTransaction: 'The transaction was not successful',
        freeCancellation: 'Free cancellation up to 7 days from the tour date'
    },
    fr: {
        errorNoExcursion: 'Je ne trouve pas l\'excursion',
        contactUs: 'Contactez-nous pour plus d\'informations',
        errorNoAvailability: 'Il n\'y a pas de places disponibles pour cette date',
        errorSelectAnotherDate: 'Sélectionnez une autre date ou contactez-nous pour plus d\'informations',
        headerCheckYourOrder: 'Vérifiez votre commande',
        headerYourData: 'Vos données',
        headerPayment: 'Paiement',
        recapHeader: 'Quelle <span style=\'color: #ff1053\'>chance</span>, il semble qu\'il y ait encore <span style=\'color: #ff1053\'>de la disponibilité</span>!',
        recapHurry: 'Mais dépêchez-vous:',
        recapHurrySeats: 'les places pourraient disparaître pendant que vous y réfléchissez!',
        recapChoice: 'Vous avez choisi:',
        adults: 'Adultes',
        children: 'Enfants (5-12 ans)',
        infant: 'Bébés (0-4 ans)',
        totPassengers: 'Tot. passagers',
        date: 'Date',
        modifyDate: 'Modifier la date',
        departureTime: 'Heure de départ',
        price: 'Prix',
        priceDetails: 'Détails du prix',
        AMPTax: 'Taxe AMP',
        totalShort: 'Total',
        recapCallToAction: 'D\'accord! Suivant',
        validationErrorFillFields: 'Remplissez tous les champs obligatoires',
        validationErrorValidEmail: 'Entrez une adresse e-mail valide',
        validationErrorBirthDay: 'Entrez une date de naissance valide (JJ/MM/AAAA)',
        validationErrorFillInvoiceFields: 'Remplissez tous les champs obligatoires pour la facturation',
        summary: 'Résumé',
        passengers: 'Passagers',
        adultsLowercase: 'adultes',
        childrenLowercase: 'enfants (5-12)',
        infantsLowercase: 'bébés (0-4)',
        personalDataCallToAction: 'Vous y êtes presque! Suivant',
        yourData: 'Vos données',
        tooltipDataFromOnePassenger: 'Il suffit de saisir les données d\'un seul passager',
        name: 'Nom',
        surname: 'Nom de famille',
        email: 'Email',
        phone: 'Téléphone',
        orderNotes: 'Notes de commande',
        travelerData: 'Données du voyageur',
        birthDayWithFormat: 'Date de naissance (JJ/MM/AAAA)',
        needInvoice: 'Besoin d\'une facture?',
        invoiceData: 'Données de facturation',
        businessName: 'Raison sociale',
        vat: 'TVA',
        fiscalCode: 'Code fiscal',
        registeredOffice: 'Siège social',
        recipientCode: 'Code destinataire ou pec',
        paymentMethod: 'Moyen de paiement',
        creditCard: 'Carte de crédit',
        paymentCallToAction: 'Payez et amusez-vous!',
        errorTransaction: 'La transaction n\'a pas réussi',
        freeCancellation: 'Annulation gratuite jusqu\'à 7 jours avant la date du tour'
    },
    de: {
        errorNoExcursion: 'Ich kann die Exkursion nicht finden',
        contactUs: 'Kontaktieren Sie uns für weitere Informationen',
        errorNoAvailability: 'Für dieses Datum sind keine Plätze verfügbar',
        errorSelectAnotherDate: 'Wählen Sie ein anderes Datum oder kontaktieren Sie uns für weitere Informationen',
        headerCheckYourOrder: 'Überprüfen Sie Ihre Bestellung',
        headerYourData: 'Ihre Daten',
        headerPayment: 'Zahlung',
        recapHeader: 'Was für ein <span style=\'color: #ff1053\'>Glück</span>, es scheint, dass es noch <span style=\'color: #ff1053\'>Verfügbarkeit</span> gibt!',
        recapHurry: 'Aber beeilen Sie sich:',
        recapHurrySeats: 'die Plätze könnten verschwinden, während Sie darüber nachdenken!',
        recapChoice: 'Sie haben gewählt:',
        adults: 'Erwachsene',
        children: 'Kinder (5-12 Jahre)',
        infant: 'Kleinkinder (0-4 Jahre)',
        totPassengers: 'Anz. Passagiere',
        date: 'Datum',
        modifyDate: 'Datum ändern',
        departureTime: 'Abfahrtszeit',
        price: 'Preis',
        priceDetails: 'Preisdetails',
        AMPTax: 'AMP-Steuer',
        totalShort: 'Gesamt',
        recapCallToAction: 'Alles klar! Weiter',
        validationErrorFillFields: 'Füllen Sie alle Pflichtfelder aus',
        validationErrorValidEmail: 'Geben Sie eine gültige E-Mail-Adresse ein',
        validationErrorBirthDay: 'Geben Sie ein gültiges Geburtsdatum ein (TT/MM/JJJJ)',
        validationErrorFillInvoiceFields: 'Füllen Sie alle Pflichtfelder für die Rechnungsstellung aus',
        summary: 'Zusammenfassung',
        passengers: 'Passagiere',
        adultsLowercase: 'erwachsene',
        childrenLowercase: 'kinder (5-12)',
        infantsLowercase: 'kleinkinder (0-4)',
        personalDataCallToAction: 'Sie sind fast da! Weiter',
        yourData: 'Ihre Daten',
        tooltipDataFromOnePassenger: 'Es reicht aus, die Daten eines einzigen Passagiers einzugeben',
        name: 'Name',
        surname: 'Nachname',
        email: 'Email',
        phone: 'Telefon',
        orderNotes: 'Bestellhinweise',
        travelerData: 'Reisende Daten',
        birthDayWithFormat: 'Geburtsdatum (TT/MM/JJJJ)',
        needInvoice: 'Benötigen Sie eine Rechnung?',
        invoiceData: 'Rechnungsdaten',
        businessName: 'Firmenname',
        vat: 'MwSt',
        fiscalCode: 'Steuernummer',
        registeredOffice: 'Geschäftssitz',
        recipientCode: 'Empfängercode oder pec',
        paymentMethod: 'Zahlungsmethode',
        creditCard: 'Kreditkarte',
        paymentCallToAction: 'Bezahlen und Spaß haben!',
        errorTransaction: 'Die Transaktion war nicht erfolgreich',
        freeCancellation: 'Kostenlose Stornierung bis 7 Tage vor dem Tourdatum'
    }    
}
export {strings};